<template>
  <div
    class="templateTwo"
    v-lazy:background-image="{
      src: data.bg,
    }"
    :style="{ backgroundColor: data.bgColor }"
  >
    <title-widge
      :title="data.title"
      :subTitle="data.subTitle"
      :fontBg="fontBg"
    ></title-widge>
    <div class="divImg">
      <img v-lazy="data.url" />
      <div class="divDesc">{{ data.desc }}</div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    fontBg: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.templateTwo {
  padding-bottom: 86px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  .divImg {
    width: 1120px;
    margin: 0 auto;
    img {
      width: 1120px;
    }
    .divDesc {
      width: 760px;
      height: 49px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      margin: 0 auto;
      text-align: center;
      margin-top: 36px;
    }
  }
}
</style>
